import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Ingrese un correo electrónico válido'),
  password: z.string().min(8, 'La contraseña debe tener al menos 8 caracteres'),
});

export type LoginInput = z.infer<typeof loginSchema>;

export const resetPasswordSchema = z.object({
  email: z.string().email('Ingrese un correo electrónico válido'),
});

export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export const confirmResetPasswordSchema = z.object({
  email: z.string().email('Ingrese un correo electrónico válido'),
  code: z.string().min(1, 'El código de verificación es requerido'),
  newPassword: z.string().min(8, 'La contraseña debe tener al menos 8 caracteres'),
});

export type ConfirmResetPasswordInput = z.infer<typeof confirmResetPasswordSchema>;

export const updateProfileSchema = z.object({
  nombre: z.string().min(2, 'El nombre debe tener al menos 2 caracteres').max(100).optional(),
  email: z.string().email('Ingrese un correo electrónico válido').optional(),
  cargo: z.string().max(100).optional().nullable(),
}).refine((data) => data.nombre !== undefined || data.email !== undefined || data.cargo !== undefined, {
  message: 'Debe proporcionar al menos un campo para actualizar',
});

export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;
